import { createAction, props } from '@ngrx/store';
import { Product } from '@b2b/features/product/core/utilities/product.model';
import { Price } from '@b2b/features/product/core/utilities/price.model';
import { GetStockResponse } from '@b2b/features/product/core/utilities/stock.model';

export const GET_PRODUCT = '[PRODUCT]: GET';
export const GET_PRODUCT_SUCCESS = '[PRODUCT]: GET - SUCCESS';
export const GET_PRODUCT_FAIL = '[PRODUCT]: GET - FAIL';
export const CLEAR_PRODUCT = '[PRODUCT]: CLEAR';

export const GET_PRICE = '[PRICE]: GET';
export const GET_PRICE_SUCCESS = '[PRICE]: GET - SUCCESS';
export const GET_PRICE_FAIL = '[PRICE]: GET - FAIL';
export const CLEAR_PRICE = '[PRICE]: CLEAR';

export const GET_STOCK = '[STOCK]: GET';
export const GET_STOCK_SUCCESS = '[STOCK]: GET - SUCCESS';
export const GET_STOCK_FAIL = '[STOCK]: GET - FAIL';
export const CLEAR_STOCK = '[STOCK]: CLEAR';

export const getProduct = createAction(GET_PRODUCT, props<{ productID: string }>());
export const getProductSuccess = createAction(GET_PRODUCT_SUCCESS, props<{ data: Product }>());
export const getProductFail = createAction(GET_PRODUCT_FAIL, props<{ erroMessage: string }>());
export const clearProduct = createAction(CLEAR_PRODUCT);

export const getPrice = createAction(GET_PRICE, props<{ productID: string }>());
export const getPriceSuccess = createAction(GET_PRICE_SUCCESS, props<{ data: Price }>());
export const getPriceFail = createAction(GET_PRICE_FAIL, props<{ erroMessage: string }>());

export const getStock = createAction(GET_STOCK, props<{ productID: string }>());
export const getStockSuccess = createAction(GET_STOCK_SUCCESS, props<{ data: GetStockResponse }>());
export const getStockFail = createAction(GET_STOCK_FAIL, props<{ erroMessage: string }>());
